import {
  RadioGroupProps,
  RadioGroup as RadioGroupRAC,
} from "react-aria-components";

export default function RadioGroup(props: RadioGroupProps) {
  return (
    <RadioGroupRAC {...props} className="flex flex-col gap-4 mt-8 w-full" />
  );
}
